<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-22 10:58:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-10-31 11:47:16
 * @FilePath: 
 * @Description: 支付方式组件
-->
<template>
  <van-radio-group class="pay_radios_con" v-model="payType">
    <van-cell-group>
      <van-cell
        title="本人手牌挂账"
        clickable
        v-if="payType===2"
        @click="payType = 2"
      >
        <template #extra>
          <van-radio :name="2">
            <template #icon="props">
              <img
                class="img-icon"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </template>
          </van-radio>
        </template>
        <template #right-icon>
          <p
            v-if="!cardCode&&vpnInfo.KeyBindComponent===0"
            style="color: #52c41a"
            class="pay_desc_con"
            @click="handleBindCard"
          >
            扫一扫绑手牌
          </p>
           <p
           v-else-if="!cardCode&&vpnInfo.KeyBindComponent===1"
            style="color: #52c41a"
            class="pay_desc_con"
            @click="callwaiter"
          >
            呼叫服务员
          </p>
          <p
           v-else-if="!cardCode&&vpnInfo.KeyBindComponent===2"
            style="color: #52c41a"
            class="pay_desc_con"
            @click="inputKeyCode"
          >
            输入手牌号
          </p>

          <p v-else class="pay_desc_con c-lightgrey"  >
            手牌号<span class="c-main-txt m-lr-10">{{ cardCode }}</span>
          </p>
        </template>
      </van-cell>

      <div v-else>
        <van-cell
          v-if="fromPage != 'pop' && payType===3"
          title="餐后付"
          clickable
          @click="changeSubmitWay(3)" 
        >
          <template #extra>
            <van-radio :name="3">
              <template #icon="props">
                <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                />
              </template>
            </van-radio>
          </template>
        </van-cell>
        <van-cell
          title="立即支付"
          v-if="payType===1"
          clickable
          @click="changeSubmitWay(1)"
        >
          <template #right-icon>
            <p class="c-lightgrey pay_desc_con">在线支付</p>
          </template>
          <template #extra>
            <van-radio :name="1">
              <template #icon="props">
                <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                />
              </template>
            </van-radio>
          </template>
        </van-cell>

        <!-- <van-cell title="他人代付" clickable @click="payType = 3">
        <template #extra>
          <van-radio :name="3">
            <template #icon="props">
              <img
                class="img-icon"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </template>
          </van-radio>
        </template>
      </van-cell> -->
      </div>
    </van-cell-group>

    <van-dialog
      title="输入手牌号"
      v-model="showPopup"
      show-cancel-button
      cancelButtonText="关闭"
      :show-confirm-button="true"
      @close="hideModel"
      @confirm="submitKeyCode"
    >
			<div class="card_bottom_con">
				<div class="popup-content">
					<div style="height: 100%;overflow-y: auto;">
						 <input class="intput-key" placeholder="请输入手牌号"  v-model="cardCode"/>
					</div>
				</div>
				<div style="height: 30rpx;width: 100%;background-color: #f5f5f5;" />
			
			</div>
		</van-dialog>

    <van-dialog
    className="call-waiter-dialog-box"
      title="温馨提示"
      show-cancel-button
      cancelButtonText="关闭"
      @close="showCallWaiterDialog=false"
      v-model="showCallWaiterDialog"
      confirmButtonText="扫码绑定手牌"
      confirmButtonColor="#52c41a"
      @confirm="handleBindCard"
  >
      <div class="call-waiter-dialog">
        系统已通知服务员，请耐心等待
      </div>
    </van-dialog>

  </van-radio-group>
</template>

<script>
import { handleSessionStorage, handleScanCode } from "@/utils";
import { getScanTakeNumber,waitercall } from "@/api/scan";
export default {
  name: "GoodsListCard",
  props: {
    // payType: {
    //   type: String,
    //   default: "3",
    // },
    fromPage: {
      //用于判断是否展示餐后付
      type: String,
      default: "2",
    },
  },
  data() {
    return {
  
      showPopup:false,
      showCallWaiterDialog:false,
      diningRoomInfo:{},
      deskInfoCode:null,
      cardCode: null,
      payType: 1,
      vpnInfo:{},
      activeIcon: require("@/assets/radio/radio-active.png"),
      inactiveIcon: require("@/assets/radio/radio-unactive.png"),
      isTableLedger: true,
    };
  },
  created() {
    this.vpnInfo = handleSessionStorage.get("vpnInfo");
    this.diningRoomInfo = handleSessionStorage.get("diningRoomInfo");
    this.vpnCode = this.vpnInfo.code;
    this.VpnId = this.vpnInfo.id;
  	this.payType = this.diningRoomInfo.PayMode
    const deskInfo = handleSessionStorage.get("deskCode");
    this.cardCode = deskInfo ? deskInfo.cardCode : "";
    this.deskInfoCode =deskInfo?deskInfo.code : ""
  },
  methods: {
    hideModel(){
      this.cardCode =null
      this.showPopup = false
    },
    submitKeyCode(){
     const deskObj = handleSessionStorage.get("deskCode");
     handleSessionStorage.set("deskCode", {
          ...deskObj,
          checkinId: "",
          cardCode: this.cardCode,
      });
      this.$emit("handleResetCardInfo");
      this.showPopup = false
    },
  inputKeyCode(){
   this.showPopup = true
  },
    changeSubmitWay (value){
     this.payType =value
      this.$emit("changeSubmitWay",this.payType);
    },
    handleBindCard() {
      // this.$emit("sweepCode", type);
      // 调起微信扫码，
      handleScanCode({ needResult: 1 }, (res) => {
        const cardCodeData = res.resultStr;
        if (!cardCodeData) {
          this.$toast("二维码为空，请确认后重新扫码");
          return;
        }
      var vpncodeQuery ="" 
      var uuidQuery = ""
      const pageQueryArr = cardCodeData.split("?M=");
      if(pageQueryArr instanceof Array && pageQueryArr.length==2){
       const orgString = pageQueryArr[1];
        const arr = orgString.split('@');
        if(arr instanceof Array && arr.length==2){
           uuidQuery = arr[0],
           vpncodeQuery = arr[1]
        } 
      }
        console.log("pageQuery 数据加载中 ==== "+uuidQuery)
        console.log("pageQuery  门店参数code  ==== "+vpncodeQuery)
        //  this.$toast("扫码拿到的数据："+uuidQuery+"vpncodeQuery"+vpncodeQuery);
        if ((!uuidQuery || !vpncodeQuery)) {
          this.$toast("二维码缺少必要参数，请确认后重新扫码");
          return;
        }
        let queryData = {
          IsBind: true,
          BindingUuid:uuidQuery,
          VpnCode:vpncodeQuery
        };
        getScanTakeNumber(queryData)
          .then((res) => {
            this.cardCode = res.TableCode;
            // this.$toast("扫码绑定结果："+JSON.stringify(res));
            const deskObj = handleSessionStorage.get("deskCode");
            handleSessionStorage.set("deskCode", {
              ...deskObj,
              checkinId: res.CheckinId,
              cardCode: res.TableCode,
            });
            this.$emit("handleResetCardInfo");
          })
          .catch((err) => {
            this.$toast("绑定手牌失败："+err)
          });
      });
    },
     //呼叫服务员
     callwaiter() {
      if(this.vpnInfo.WaiterCallPurpose==1){
          this.$emit("callwaiter");
      }else {
       waitercall({
       VpnId:this.VpnId,
       TableCode:this.deskInfoCode
     }).then((res)=>{
        this.showCallWaiterDialog = true
     }).catch((err) => {
       this.$toast("呼叫服务员失败："+err)
     });
      }
 
     },
    getQueryVariable(url, variable) {
      const vars = url.split("&");
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.pay_radios_con {
  .pay_desc_con {
    width: 170px;
  }
  .van-radio {
    margin-right: 8px;
  }
  .img-icon {
    width: 30px;
  }
}

.card_bottom_con {
  background: #fff;
  margin: 10px;
  padding-bottom: 1rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.popup-title {
  text-align: center;
  height: 100px;
  padding-top: 30px;
  width: 100%;
  color: black;
  font-size: 36px;
  font-weight: 500;
  border-bottom: 1px solid #f3f3f3;
}

.popup-content {
  height: 5rem;
  width: 100%;
  color: black;
  font-size: 20px;
}
.intput-key{
 height: 80px;
 width: 95%;
 font-size: 1rem;
 padding-left: 10px;
 margin-top: 10px;
 background-color: transparent;
 border: 1px solid lightgray;
 border-radius: 4px;
 text-align: center;
}
::v-deep .call-waiter-dialog-box .van-dialog__confirm .van-button__text {
  color: #52c41a !important;
}
::v-deep .call-waiter-dialog-box .van-dialog__header {
  color: #000;
}
.call-waiter-dialog {
  padding: 26px;
  text-align: center;
  color: #000;
  font-size: 30px;
}

</style>
